var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('tipsDailog', {
    staticClass: "audioSettingDailog",
    attrs: {
      "info": _vm.audiSettingInfo
    },
    on: {
      "cancel": function ($event) {
        return _vm.cancelAudioSetting();
      },
      "save": function ($event) {
        return _vm.setAduioSetting();
      }
    }
  }, [_c('div', {
    staticClass: "middles"
  }, [_c('div', {
    staticClass: "audioMode"
  }, [_c('div', {
    staticClass: "tipsContent"
  }, [_c('div', {
    staticClass: "tips"
  }, [_vm._v(_vm._s(_vm.$t('common.audioFormat')))]), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('common.audioOutput')))]), _c('p', [_vm._v(_vm._s(_vm.$t('common.selectTips')))])]), _c('i', {
    staticClass: "iconfont icon-help2",
    staticStyle: {
      "color": "#909090"
    }
  })])], 1), _c('el-radio-group', {
    on: {
      "change": _vm.onAudioModeChange
    },
    model: {
      value: _vm.audioMode,
      callback: function ($$v) {
        _vm.audioMode = $$v;
      },
      expression: "audioMode"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "mono"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.mono')))]), _c('el-radio', {
    attrs: {
      "label": "stereo"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.stereo')))])], 1)], 1), _c('div', {
    staticClass: "audioQuality"
  }, [_c('div', {
    staticClass: "tips"
  }, [_vm._v(_vm._s(_vm.$t('common.audioQuality')))]), _c('el-select', {
    attrs: {
      "popper-append-to-body": false,
      "placeholder": "Select Audio Profile"
    },
    on: {
      "change": val => {
        _vm.saveOperation('audioProfile', val);
      }
    },
    model: {
      value: _vm.audioProfile,
      callback: function ($$v) {
        _vm.audioProfile = $$v;
      },
      expression: "audioProfile"
    }
  }, _vm._l(_vm.profiles, function (profile) {
    return _c('el-option', {
      key: profile.value,
      attrs: {
        "label": profile.text,
        "value": profile.value
      }
    });
  }), 1)], 1), _c('div', {
    staticClass: "threeASetting"
  }, [_c('div', {
    staticClass: "tipsContent"
  }, [_c('div', {
    staticClass: "tips"
  }, [_vm._v(_vm._s(_vm.$t('common.noisTips')))]), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "placement": "bottom"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('common.stereoNoOptions')))])]), _c('i', {
    staticClass: "iconfont icon-help2",
    staticStyle: {
      "color": "#909090"
    }
  })])], 1), _vm._l(_vm.audioSettingList, function (item) {
    return _c('div', {
      key: item.type,
      staticClass: "settingLi"
    }, [_c('el-checkbox', {
      staticClass: "greenStyle",
      attrs: {
        "disabled": _vm.audioMode === 'stereo'
      },
      on: {
        "change": val => {
          _vm.saveOperation(`${item.localKey}`, item.checked);
        }
      },
      model: {
        value: item.checked,
        callback: function ($$v) {
          _vm.$set(item, "checked", $$v);
        },
        expression: "item.checked"
      }
    }), _c('span', {
      staticClass: "type"
    }, [_vm._v(_vm._s(item.type))]), _c('span', {
      staticClass: "tips"
    }, [_vm._v(_vm._s(_vm.$t(`${item.i18n}`)))])], 1);
  })], 2)])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };